import { VueCharts, mixins } from 'vue-chartjs';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';

const { reactiveProp } = mixins;

const barchartData = {
  labels: ['a', 'b'],
  datasets: [
    {
      backgroundColor: '#FF0000',
      data: [12.5, 0],
      labels: ['a', 'b'],
      borderWidth: 1,
      borderSkipped: false,
      datalabels: {
        anchor: 'top',
        align: 'start',
        color: '#000000',
        clamp: true,
        display: true,
        font: {
          family: "Stag-Black",
          weight: 'bold'
        },
        formatter(value) {
          return value > 0 ? 'Reactive' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#FF0000',
      data: [25,0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 25,
        color: '#000000',
        family: "Stag-Sans-Book",
        textAlign: 'center',
        font: {
          size: 16,
          weight: 'bold',
          family: "Stag-Black"
        },
        formatter(value) {
          return value > 0 ? '1st' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#FFC000',
      data: [37.5, 0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        color: '#000000',
        textAlign: 'center',
        font: {
          size: 12,
          weight: 'bold',
          family: "Stag-Black"
        },
        formatter(value) {
          return value > 0 ? 'Compliant' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#FFC000',
      data: [50, 0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 25,
        color: '#000000',
        family: "Stag-Black",
        textAlign: 'center',
        font: {
          family: "Stag-Black",
          size: 16,
          weight: 'bold'
        },
        formatter(value) {
          return value > 0 ? '2nd' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#FFFF00',
      data: [62.5,0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        color: '#000000',
        textAlign: 'center',
        font: {
          weight: 'bold',
          family: "Stag-Black"
        },
        formatter(value) {
          return value > 0 ? 'Engaged' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#FFFF00',
      data: [75, 0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 30,
        color: '#000000',
        textAlign: 'center',
        font: {
          size: 16,
          weight: 'bold',
          family: "Stag-Black"
        },
        formatter(value) {
          return value > 0 ? '3rd' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#92D050',
      data: [87.5, 0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        color: '#000000',
        textAlign: 'center',
        font: {
          size: 10,
          weight: 'bold',
          family: "Stag-Black"
        },
        formatter(value) {
          return value > 0 ? 'HIGH\nPERFORMING' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: '#92D050',
      data: [100,0],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 30,
        color: '#000000',
        textAlign: 'center',
        font: {
          family: "Stag-Black",
          size: 16,
          weight: 'bold'
        },
        formatter(value) {
          return value > 0 ? '4th' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: 'rgba(0, 0, 0, 0)',
      data: [0, 25],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 15,
        color: '#000000',
        font: {
          family: "Stag-Black"
        },
        textAlign: 'left',
        formatter(value) {
          return value > 0 ? 'Lack of awareness of critical\nbest practice standards and\ntheir impact.  Poor\naccountability.' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: 'rgba(0, 0, 0, 0)',
      data: [0, 50],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 15,
        color: '#000000',
        font: {
          family: "Stag-Black"
        },
        textAlign: 'left',
        formatter(value) {
          return value > 0 ? 'Awareness of critical safety\nrequirements.  Evidence that\nindividual and organisational\ncapacity is being built.' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: 'rgba(0, 0, 0, 0)',
      data: [0, 75],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 30,
        color: '#000000',
        font: {
          family: "Stag-Black"
        },
        textAlign: 'left',
        formatter(value) {
          return value > 0 ? 'Greater collaboration by all\nto proactively address all the\nstandards.' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    },
    {
      labels: ['a', 'b'],
      backgroundColor: 'rgba(0, 0, 0, 0)',
      data: [0, 100],
      borderWidth: 0,
      borderSkipped: true,
      datalabels: {
        anchor: 'top',
        align: 'start',
        offset: 15,
        color: '#000000',
        font: {
          family: "Stag-Black"
        },
        textAlign: 'left',
        formatter(value) {
          return value > 0 ? 'High performing teams, at all\nlevels of organisation,\nconsistently driving\nexcellence.' : '';
        }
      },
      xAxisID: 'thick',
      stack: 'thick'
    }
  ]
};

export default {
  extends: VueCharts.Bar,
  mixins: [reactiveProp],
  props: ['chartData'],
  components: {
    ChartJsPluginDataLabels
  },
  mounted() {
    this.addPlugin({
      beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'white';
        ctx.fillRect(
          0,
          0,
          chartInstance.chart.width,
          chartInstance.chart.height
        );
      }
    });
    const that = this;
    this.renderChart(barchartData, {
      events: [],
      tooltips: { enabled: false },
      hover: { mode: null },
      responsive: false,
      maintainAspectRatio: true,
      title: {
        display: false,
        text: 'Chart.js Bar Chart - Stacked'
      },
      legend: false,
      layout: {
        padding: {
          right: 15,
          top: 10,
          bottom: 0
        }
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            display: true,
            ticks: { display: false },
            gridLines: { display: false, drawBorder: false},
            id: 'thick',
            type: 'category',
            labels: ['a', 'b'],
            drawBorder: false,
            categoryPercentage: 1,
            barPercentage: 1
          }
        ],
        yAxes: [
          {
            display: true,
            stacked: false,
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            },
            ticks: {
              display: false,
              min: 0, max: 100, stepSize: 25,
              beginAtZero: true
            },
            gridLines: {
              display: true,
              color: '#000',
              lineWidth: 1,
              borderDashOffset: -167,
              borderDash: [350, 325],
              zeroLineColor: '#000000',
              zeroLineWidth: 1,
              zeroLineBorderDashOffset: -150,
              drawBorder: false,
              drawOnChartArea: true,
              drawTicks: false
            }
          }
        ]
      },
      showTooltips: false,
      // you are here x mark
      // right hand bars
      animation: {
        onComplete() {
          const ctx = this.ctx; // eslint-disable-line prefer-destructuring
          const chartHeight = (this.chartArea.bottom + 21) - (this.chartArea.top + 21);
          //right hand bars
          ctx.fillStyle = '#92D050';
          ctx.fillRect(324,this.chartArea.top + 2,14,chartHeight/4 - 2);
          ctx.fillStyle = '#FFFF00';
          ctx.fillRect(324,this.chartArea.top + chartHeight/4,14,chartHeight/4);
          ctx.fillStyle = '#FFC000';
          ctx.fillRect(324,this.chartArea.top + chartHeight/4*2,14,chartHeight/4);
          ctx.fillStyle = '#FF0000';
          ctx.fillRect(324,this.chartArea.top + chartHeight/4*3,14,chartHeight/4);

          // chevron you are here x
          
          ctx.font = 'bold 40px Arial';
          ctx.fillStyle = 'black';
          ctx.fillText('⮝', 314, 28);
          

          const gearScores = [0, 60, 70, 80, 100];
          const score = that.chartData;
          const percentage = gearScores.reduce((accumulator, value, index) => {
            if (!accumulator && score < value) {
              const bandWidth = value - gearScores[index - 1];
              accumulator = (25 * (score - gearScores[index - 1]) / bandWidth) + ((index - 1) * 25);// eslint-disable-line no-param-reassign
            }
            return accumulator;
          }, null);
          const yposition = 30 + (chartHeight * (100 - percentage) / 100);

          ctx.font = 'bold 60px Arial';
          ctx.fillText('✘', 310, yposition);
          ctx.font = 'normal 14px Stag-Black';
          ctx.fillText('You are\nHERE', 350, yposition - 15);
        }
      },
      plugins: {
        datalabels: {
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/graphs/ChevronAndX.js